import { render, staticRenderFns } from "./Rankrequest.vue?vue&type=template&id=f8c90c3e&scoped=true&"
import script from "./Rankrequest.vue?vue&type=script&lang=js&"
export * from "./Rankrequest.vue?vue&type=script&lang=js&"
import style0 from "./Rankrequest.vue?vue&type=style&index=0&id=f8c90c3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8c90c3e",
  null
  
)

export default component.exports